module.exports = __parcel__import__.meta.resolve("42R5K");